export function getHeaders (token) {
  const headers = {
    'content-type': 'application/json',
    Authorization: `Bearer ${token}`,
  }

  return headers
}
